import { get } from "@/services/axiosUitils";
import {
  IActivityLogResponseById,
  IApiResponse,
} from "@/utils/types/activityLogs";

const base = "/tenant-core/activity-logs/";

class ActivityLogsService {
  listActivityLogs = async (
    page: number,
    pageSize: number
  ): Promise<IApiResponse> => {
    return await get<IApiResponse>(base, {
      params: {
        page,
        page_size: pageSize,
      },
    });
  };

  getActivityLog = async (id: string): Promise<IActivityLogResponseById> => {
    return await get<IActivityLogResponseById>(`${base}${id}/`);
  };
}

export default new ActivityLogsService();
